import { Link } from "react-router-dom";
import { specialList } from "@/mocks/specials";
import SectionHeading from "@/components/base/SectionHeading";

export default function SpecialSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <SectionHeading
        eyebrow="专题策划"
        title="影视专题推荐"
        description="围绕主题与类型精心策划的合集，带你成体系地发现好作品。"
        action={
          <Link
            to="/special"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            全部专题
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        {specialList.slice(0, 4).map((sp) => (
          <Link
            key={sp.id}
            to="/special"
            className="group relative block rounded-lg overflow-hidden bg-primary-950 h-56 md:h-64"
          >
            <img
              src={sp.cover}
              alt={`${sp.title} 影视专题`}
              title={sp.title}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
              <span className="inline-flex self-start px-2.5 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-bold mb-3">
                {sp.subtitle}
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-2">{sp.title}</h3>
              <p className="text-xs md:text-sm text-background-100/80 leading-relaxed line-clamp-2 max-w-md">
                {sp.intro}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}